module.exports = __webpack_public_path__ + "img/kommune-1418.c8bb803c.svg";